"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const styles_1 = __importDefault(require("./styles"));
const ChangePasswordScreen = () => {
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                alignSelf: "center",
            }, title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4", styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.headerBackLabel }, "\u30AD\u30E3\u30F3\u30BB\u30EB") }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.body },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.row },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.rectangle }),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.title }, "\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4\u5B8C\u4E86")),
            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.description }, "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5909\u66F4\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002"),
            react_1.default.createElement(components_1.BorderButton, { title: "\u8A2D\u5B9A\u753B\u9762\u306B\u623B\u308B", style: styles_1.default.backButton, textStyle: styles_1.default.backButtonLabel, onPress: rootNavigation_1.goBack }))));
};
exports.default = ChangePasswordScreen;
